const isNumericString = (input) => {
    return /^[0-9]+$/.test(input);
};

export const isValidFormPayment = (number) => {
    return number.trim() && isNumericString(number.trim());
};
